<div class="resolution" *ngIf="resolutions.length > 1">
    <mat-menu #resolutionMenu="matMenu" yPosition="below" xPosition="before" class="resolution-menu">
        <div class="resolution-header">{{ 'PLAYBACK_CONTROLS.QUALITY' | translate }}</div>
        <div class="menu-item-button-group">
            <button mat-menu-item
                    *ngFor="let resolution of resolutions"
                    [ngClass]="{'current': current === resolution}"
                    [disabled]="isNotAvailable(resolution)"
                    (click)="applyResolution(resolution)"
                    class="resolution-item-button"
            >
                {{resolution}}
                <span class="off-screen" *ngIf="current === resolution">{{ 'PLAYBACK_CONTROLS.SELECTED' | translate }}</span>
                <div class="hd-resolution" *ngIf="hdResolutions.includes(resolution)">{{ 'PLAYBACK_CONTROLS.HD' | translate }}</div>
            </button>
        </div>
    </mat-menu>

  <div mat-icon-button class="resolution-button" [matMenuTriggerFor]="resolutionMenu" (menuOpened)="menuOpen()" (menuClosed)="menuClose()">
      <i class="pbi-icon-mini pbi-settings lg text-white"></i>
  </div>
</div>
